import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { usePositionsContext } from "../../../context/positionsContext";
import { FilterTimeRange } from "../../../context/positionsContext";

const OPTIONS: { value: FilterTimeRange; label: string }[] = [
  { value: "7", label: "7D" },
  { value: "14", label: "14D" },
  { value: "30", label: "30D" },
  { value: "90", label: "90D" },
  { value: "all", label: "All" },
];

export const PositionsFilter = () => {
  const { timeRange, setTimeRange } = usePositionsContext();

  return (
    <ToggleButtonGroup
      size="small"
      exclusive
      value={timeRange}
      aria-label="Time range"
      // Ignore deselect (null) so a range is always selected
      onChange={(_, value: FilterTimeRange | null) =>
        value && setTimeRange(value)
      }
    >
      {OPTIONS.map((option) => (
        <ToggleButton
          key={option.value}
          value={option.value}
          sx={{ px: 1.5, py: 0.25, textTransform: "none" }}
        >
          {option.label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};
